import * as React from 'react';

import { PageTitleBar } from 'components';

const ShippingConfigHeader = ({
  children,
}: React.PropsWithChildren<unknown>) => <PageTitleBar headerTitle={children} />;

export { ShippingConfigHeader };
